import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

const generateColor = (index) => {
  const baseColors = ["#74CB80", "#FF7BD7", "#F56B62", "#197FC7", "#56B6FC"];
  if (index < baseColors.length) return baseColors[index];

  // Generate a unique color variation using HSL manipulation
  const hueShift = (index * 137) % 360; // Spread colors evenly across hue spectrum
  return `hsl(${hueShift}, 60%, 65%)`; // Pastel-midtone color
};

const convertToDecimalHours = (timeString) => {
  if (!timeString || typeof timeString !== "string") {
    return 0; // Return 0 if the value is undefined or not a string
  }
  const [hours, minutes] = timeString.split(":").map(Number);
  return hours + minutes / 60;
};

const ProjectPieChart = ({
  projectName,
  overallActualHours,
  overallBudgetHours,
}) => {
  const actualHours = convertToDecimalHours(overallActualHours);
  const budgetHours = convertToDecimalHours(overallBudgetHours);
  const chartData = useMemo(
    () => [
      {
        name: "Actual Hours",
        value: actualHours,
        itemStyle: { color: generateColor(0) },
      },
      {
        name: "Budget Hours",
        value: budgetHours,
        itemStyle: { color: generateColor(1) },
      },
    ],
    [actualHours, budgetHours]
  );

  const option = {
    title: {
      left: "center",
      textStyle: { fontSize: 18, fontWeight: "bold" },
      subtextStyle: { fontSize: 14, color: "#666" },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} hours", // Removed percentage
    },
    legend: {
      orient: "vertical",
      bottom: "10px",
      right: "right",
    },
    series: [
      {
        name: "Project Hours",
        type: "pie",
        radius: "80%",
        data: chartData,
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(179, 74, 74, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <div className="project-status">
      <h2 className="pie-chart-summary">Duration Summary - {projectName}</h2>
      {actualHours > 0 || budgetHours >= 0 ? (
        <ReactECharts
          className="pie-chart"
          option={option}
          style={{ height: "400px" }}
        />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default ProjectPieChart;
